import {AutogenLayoutWireCodeList} from "./autogen/AutogenLayoutWireCodeList";

export class WireCodeList extends AutogenLayoutWireCodeList {

    override onLoad(): void | Promise<void> {
        this.mainDataSource.search();
    }

}
